!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ccp = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ccp",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "𑄝𑄧𑄏𑄧𑄢𑄴",
        relative: {
          0: "𑄃𑄬 𑄝𑄧𑄏𑄧𑄢𑄴",
          1: "𑄎𑄬𑄢𑄧 𑄝𑄧𑄏𑄧𑄢𑄴",
          "-1": "𑄉𑄬𑄣𑄳𑄠𑄬 𑄝𑄧𑄏𑄧𑄢𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄝𑄧𑄏𑄧𑄢𑄬",
            other: "{0} 𑄝𑄧𑄏𑄧𑄢𑄬"
          },
          past: {
            one: "{0} 𑄝𑄧𑄏𑄧𑄢𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄝𑄧𑄏𑄧𑄢𑄴 𑄃𑄉𑄬"
          }
        }
      },
      "year-short": {
        displayName: "𑄝𑄧𑄏𑄧𑄢𑄴",
        relative: {
          0: "𑄃𑄳𑄆𑄬 𑄝𑄧𑄏𑄧𑄢𑄴",
          1: "𑄛𑄧𑄢𑄬 𑄝𑄧𑄏𑄧𑄢𑄴",
          "-1": "𑄉𑄬𑄣𑄳𑄠𑄬 𑄝𑄧𑄏𑄧𑄢𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄝𑄧𑄏𑄧𑄢𑄬",
            other: "{0} 𑄝𑄧𑄏𑄧𑄢𑄬"
          },
          past: {
            one: "{0} 𑄝𑄧𑄏𑄧𑄢𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄝𑄧𑄏𑄧𑄢𑄴 𑄃𑄉𑄬"
          }
        }
      },
      month: {
        displayName: "𑄟𑄏𑄴",
        relative: {
          0: "𑄃𑄳𑄆𑄬 𑄟𑄏𑄴",
          1: "𑄛𑄧𑄢𑄬 𑄟𑄏𑄴",
          "-1": "𑄉𑄬𑄣𑄧𑄘𑄬 𑄟𑄏𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄟𑄏𑄬",
            other: "{0} 𑄟𑄏𑄬"
          },
          past: {
            one: "{0} 𑄟𑄏𑄧 𑄃𑄉𑄬",
            other: "{0} 𑄟𑄏𑄧 𑄃𑄉𑄬"
          }
        }
      },
      "month-short": {
        displayName: "𑄟𑄏𑄴",
        relative: {
          0: "𑄃𑄳𑄆𑄬 𑄟𑄏𑄴",
          1: "𑄛𑄧𑄢𑄬 𑄟𑄏𑄴",
          "-1": "𑄉𑄬𑄣𑄧𑄉𑄬 𑄟𑄏𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄟𑄏𑄬",
            other: "{0} 𑄟𑄏𑄬"
          },
          past: {
            one: "{0} 𑄇𑄏𑄧 𑄃𑄉𑄬",
            other: "{0} 𑄟𑄏𑄧 𑄃𑄉𑄬"
          }
        }
      },
      day: {
        displayName: "𑄘𑄨𑄚𑄴",
        relative: {
          0: "𑄃𑄬𑄌𑄴𑄥𑄳𑄠",
          1: "𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄳𑄠𑄬",
          2: "𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄬 𑄛𑄧𑄢𑄴𑄥𑄪",
          "-2": "𑄉𑄬𑄣𑄧𑄘𑄬 𑄛𑄧𑄢𑄴𑄥𑄪",
          "-1": "𑄉𑄬𑄣𑄴𑄣𑄳𑄠𑄇𑄬𑄣𑄳𑄠𑄬"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄘𑄨𑄚𑄮 𑄟𑄧𑄖𑄴𑄙𑄳𑄠",
            other: "{0} 𑄘𑄨𑄚𑄮 𑄟𑄧𑄖𑄴𑄙𑄳𑄠"
          },
          past: {
            one: "{0} 𑄘𑄨𑄚𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄘𑄨𑄚𑄴 𑄃𑄉𑄬"
          }
        }
      },
      "day-short": {
        displayName: "𑄘𑄨𑄚𑄴",
        relative: {
          0: "𑄃𑄬𑄌𑄴𑄥𑄳𑄠𑄬",
          1: "𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬",
          2: "𑄃𑄬𑄎𑄬𑄖𑄴𑄖𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬 𑄛𑄧𑄢𑄴𑄥𑄪",
          "-2": "𑄉𑄬𑄣𑄧𑄘𑄬 𑄛𑄧𑄢𑄴𑄥𑄪",
          "-1": "𑄉𑄬𑄣𑄴𑄣𑄳𑄠𑄇𑄬𑄣𑄴𑄣𑄳𑄠𑄬"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄘𑄨𑄚𑄮 𑄟𑄧𑄖𑄴𑄙𑄳𑄠",
            other: "{0} 𑄘𑄨𑄚𑄮 𑄟𑄧𑄖𑄴𑄙𑄳𑄠"
          },
          past: {
            one: "{0} 𑄘𑄨𑄚𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄘𑄨𑄚𑄴 𑄃𑄉𑄬"
          }
        }
      },
      hour: {
        displayName: "𑄊𑄮𑄚𑄴𑄓",
        relative: {
          0: "𑄃𑄳𑄆𑄬 𑄊𑄮𑄚𑄴𑄓𑄠𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄊𑄮𑄚𑄴𑄓𑄠𑄴",
            other: "{0} 𑄊𑄮𑄚𑄴𑄓𑄠𑄴"
          },
          past: {
            one: "{0} 𑄊𑄮𑄚𑄴𑄓 𑄃𑄉𑄬",
            other: "{0} 𑄊𑄮𑄚𑄴𑄓 𑄃𑄉𑄬"
          }
        }
      },
      "hour-short": {
        displayName: "𑄊𑄮𑄚𑄴𑄓",
        relative: {
          0: "𑄃𑄳𑄆𑄬 𑄊𑄮𑄚𑄴𑄓𑄠𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄊𑄮𑄚𑄴𑄓𑄠𑄴",
            other: "{0} 𑄊𑄮𑄚𑄴𑄓𑄠𑄴"
          },
          past: {
            one: "{0} 𑄊𑄮𑄚𑄴𑄓 𑄃𑄉𑄬",
            other: "{0} 𑄊𑄮𑄚𑄴𑄓 𑄃𑄉𑄬"
          }
        }
      },
      minute: {
        displayName: "𑄟𑄨𑄚𑄨𑄖𑄴",
        relative: {
          0: "𑄃𑄳𑄆𑄬 𑄟𑄨𑄚𑄨𑄖𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄟𑄨𑄚𑄨𑄘𑄬",
            other: "{0} 𑄟𑄨𑄚𑄨𑄘𑄬"
          },
          past: {
            one: "{0} 𑄟𑄨𑄚𑄨𑄖𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄟𑄨𑄚𑄨𑄖𑄴 𑄃𑄉𑄬"
          }
        }
      },
      "minute-short": {
        displayName: "𑄟𑄨𑄚𑄨𑄖𑄴",
        relative: {
          0: "𑄃𑄳𑄆𑄬 𑄟𑄨𑄚𑄨𑄖𑄴"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄟𑄨𑄚𑄨𑄘𑄬",
            other: "{0} 𑄟𑄨𑄚𑄨𑄘𑄬"
          },
          past: {
            one: "{0} 𑄟𑄨𑄚𑄨𑄖𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄟𑄨𑄚𑄨𑄖𑄴 𑄃𑄉𑄬"
          }
        }
      },
      second: {
        displayName: "𑄥𑄬𑄉𑄬𑄚𑄴",
        relative: {
          0: "𑄃𑄨𑄇𑄴𑄅𑄚𑄪"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴𑄘𑄬",
            other: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴𑄘𑄬"
          },
          past: {
            one: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴 𑄃𑄉𑄬"
          }
        }
      },
      "second-short": {
        displayName: "𑄥𑄬𑄉𑄬𑄚𑄴",
        relative: {
          0: "𑄃𑄨𑄇𑄴𑄅𑄚𑄪"
        },
        relativeTime: {
          future: {
            one: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴𑄘𑄬",
            other: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴𑄘𑄬"
          },
          past: {
            one: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴 𑄃𑄉𑄬",
            other: "{0} 𑄥𑄬𑄉𑄬𑄚𑄴 𑄃𑄉𑄬"
          }
        }
      }
    }
  }, {
    locale: "ccp-IN",
    parentLocale: "ccp"
  }];
});